var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPennsylvania(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 36,
    viewBox: "0 0 72 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9209 0.917969L54.0918 1.55469L54.1914 1.9248H55.374L56.8867 4.83398L56.9414 4.9375L57.0361 5.00684L58.6895 6.21191L58.8574 6.33398L59.0615 6.30176L59.9121 6.16797L60.207 6.36914L59.5166 7.32324L59.4141 7.46484L59.4219 7.63965L59.4697 8.70312L57.8867 11.5371L57.7178 11.8379L57.9395 12.1016L58.583 12.8691L58.3291 13.5889L57.8604 14.0566L57.6826 14.2324L57.7178 14.4805L57.9932 16.4531L58.0361 16.7607L58.3311 16.8584L59.5879 17.2744L60.0566 18.5801L60.123 18.7637L60.2969 18.8545L61.415 19.4365L63.1797 20.7734L61.873 21.7979L61.8145 21.8438L61.7715 21.9053L60.8896 23.165L60.8799 23.1797L60.8711 23.1934L59.9688 24.6875L59.251 24.9561L59.125 25.0029L59.04 25.1055L58.4951 25.7627L57.9463 25.5586L57.8164 25.5107L57.6797 25.5361L56.7979 25.7002L56.6865 25.7207L56.5947 25.7881L55.7686 26.3906L55.6826 26.4531L55.6299 26.5449L55.0811 27.4971L21.96 33.9199L12.877 35.4248L11.1943 25.125V25.124L8.55176 9.09961L10.0469 8.33496L10.1279 8.29395L10.1895 8.22559L11.5498 6.72168L11.8584 6.68848L12.0029 6.67285L12.1162 6.58105L13.7393 5.27441L14.0635 7.68262L14.1338 8.20898L14.6553 8.10742L53.3145 0.52832L53.9209 0.917969Z",
    fill: "#E4E4E4",
    stroke: "#7C7C7C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 25,
    r: 2,
    fill: "#E3000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennsylvania);
export default __webpack_public_path__ + "static/media/pennsylvania.c55ad4733a9c302f8c57a8d634cead4e.svg";
export { ForwardRef as ReactComponent };